import { ApiResponse } from "@Services/constServices";
import { getAppointmentById_service } from "@Services/reservation/getAppointmentById.service";
import { capitalizeFirstLetters } from "@Utilities/capitalizeFirstLetters";

export const getAppointmentById_adapter = async (id: number) => {
  const response = await getAppointmentById_service(id);
  if (!response.isSuccess) {
    return response;
  }

  // handleSuccessfulResponse ya extrae response.data.data, entonces aquí es response.data directamente
  const data = response.data;

  const adaptItems = data.services.map((item) => ({
    id: item.reserveDetailId,
    service: item.priceServiceId,
    // "Por asignar": backend devuelve employeeId null/0 → el combo usa value "".
    employee:
      item.employeeId == null || item.employeeId === 0
        ? ""
        : String(item.employeeId),
    schedule: item.hourReserve,
    duration: item.serviceDuration,
    isFija: item.isFija === true || item.isFija === 1,
  }));

  const adaptClient = {
    name: capitalizeFirstLetters(data.clientFirstName),
    surname: capitalizeFirstLetters(data.clientLastName),
    birthDate: data.clientBirthday || "Sin especificar",
    documentTypeId: data.clientDocumentTypeId || 2,
    document: data.clientDocument || "Sin especificar",
    category: data.clientCategoryName || "Sin especificar",
    email: data.clientEmail || "Sin especificar",
    phone: data.clientPhone || "Sin especificar",
    id: data.clientId,
  };

  const statusReserve = data.status;
  return {
    isSuccess: response.isSuccess,
    status: response.status,
    message: response.message,
    data: {
      services: adaptItems,
      client: adaptClient,
      statusReserve: statusReserve,
      dateReserve: data.dateReserve,
      observation: data.observation,
    },
  };
};
